export default __webpack_public_path__ + "static/media/icone-pilula.4ef386a1.svg";